/**
 * Make webpack import all files from a given context (see
 * https://webpack.js.org/guides/dependency-management/#context-module-api).
 * In order to preserve static dependency analysis, the call to require.context()
 * must be made by the caller, with only literals as arguments.
 * @param {Object} context - Webpack context object produced by require.context
 * @returns {Object} map of filenames => imported contents
 * @example
 * importAll(require.context(`.`, true, /index\.js$/));
 * // import all index.js files from subdirs of the current dir
 */
export function importAll(context) {
  return context.keys().reduce((obj, key) => ({...obj, [key]: context(key)}), {});
}
